module.exports = __webpack_public_path__ + "static/media/2.b94cab84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/mozyr/2.jpg
// module id = 239
// module chunks = 0